import type { ReactNode } from 'react';

interface AuthCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function AuthCard({ title, subtitle, children }: AuthCardProps) {
  return (
    <div className="max-w-md w-full mx-auto px-4 py-8">
      <div className="bg-ll-surface border border-ll-border rounded-2xl p-8 shadow-[0_24px_80px_rgba(0,0,0,0.5)]">
        <h1 className="text-2xl font-bold text-ll-text mb-1">{title}</h1>
        {subtitle && <p className="text-sm text-ll-muted mb-6">{subtitle}</p>}
        {!subtitle && <div className="mb-6" />}
        {children}
      </div>
    </div>
  );
}
